import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Checkbox, Button } from '~/shared/components';
import { StyledFilter, StyledLabel, StyledItemCount } from './styled';

export type FilterType = {
    keyName?: string;
    label: string;
    count?: number;
    value?: string[];
    isRefined?: boolean; // This key value is inherited from the Hit type. Name should match.
    isToggleButton?: boolean;
    isFromAccordion?: boolean;
};

type FilterProps = FilterType & {
    changeHandler: (value: string[]) => void;
    attribute: string;
};

export const Filter = ({
    label,
    count,
    value,
    isRefined,
    changeHandler,
    isToggleButton,
}: FilterProps) => {
    const [isSelected, setIsSelected] = useState(isRefined);

    const toggleFacet = async (facetValue?: string[]) => {
        if (facetValue) {
            changeHandler?.(facetValue);
        }
    };

    const handleClick = (e: SyntheticEvent) => {
        if (isToggleButton) {
            setIsSelected(!isSelected);
            e.stopPropagation();
            toggleFacet(value);
        }

        return;
    };

    useEffect(() => {
        setIsSelected(isRefined);
    }, [isRefined]);

    const labelComponent = (
        <StyledLabel
            isToggleButton={isToggleButton}
            htmlFor={encodeURIComponent(label)}
            title={label}
        >
            {label}
            {!isToggleButton ? <StyledItemCount>({count})</StyledItemCount> : null}
        </StyledLabel>
    );

    return (
        <StyledFilter
            as={isToggleButton ? Button : 'div'}
            isToggleButton={isToggleButton}
            variant={isSelected ? 'primary' : 'secondary'}
            onClick={handleClick}
        >
            {!isToggleButton ? (
                <Checkbox
                    checked={isSelected}
                    id={encodeURIComponent(label)}
                    fillRow={true}
                    onChange={(e: SyntheticEvent) => {
                        setIsSelected(!isSelected);
                        e.stopPropagation();
                        toggleFacet(value);
                    }}
                    label={labelComponent}
                />
            ) : (
                labelComponent
            )}
        </StyledFilter>
    );
};
